import { IOption } from '@cbridge-utils/options';
import { IApiSymbol, IApiNewSymbol, IApiSymbolDetails } from '@cbridge-packages/api';
import { ScheduleTranslator } from '@cbridge-packages/schedule';
import { fromMillisecondsToSeconds, fromSecondsToMilliseconds } from '@cbridge-utils/shared-helpers';
import type { ISymbol, ISymbolForm, ISymbolDetails } from './symbol.interface';

export namespace SymbolTranslator {
  export function fromApi(symbol: IApiSymbol): ISymbol {
    return {
      symbolId: symbol.id,
      symbolGroup: symbol.symbolGroup,
      name: symbol.name,
      baseAsset: symbol.baseAsset,
      priceDigits: symbol.priceDigits,
      quoteAsset: symbol.quoteAsset,
      volumeDigits: symbol.volumeDigits,
      pricingTimeout: fromMillisecondsToSeconds(symbol.pricingTimeout),
      throttlingInterval: symbol.throttlingInterval,
      scheduleId: symbol.schedule?.id,
      scheduleName: symbol.schedule?.name,
    };
  }

  export function fromApiDetails(symbol: IApiSymbolDetails): ISymbolDetails {
    const result: ISymbolDetails = SymbolTranslator.fromApi(symbol);
    result.schedule = symbol.schedule && ScheduleTranslator.fromApiFullView(symbol.schedule);

    return result;
  }

  export function toApi(symbol: Partial<ISymbolForm>): IApiNewSymbol {
    return {
      symbolGroup: symbol.symbolGroup,
      name: symbol.name,
      baseAsset: symbol.baseAsset
        ? symbol.baseAsset
        : undefined,
      priceDigits: symbol.priceDigits,
      quoteAsset: symbol.quoteAsset,
      volumeDigits: symbol.volumeDigits,
      pricingTimeout: fromSecondsToMilliseconds(symbol.pricingTimeout),
      // a cleared field is omitted; BE then falls back to its default
      throttlingInterval: symbol.throttlingInterval ?? undefined,
      scheduleId: symbol.scheduleId,
    };
  }

  export function fromApiExcludedDetails(symbol: IApiSymbol): IOption {
    return {
      value: symbol.id,
      label: symbol.name,
      group: symbol.symbolGroup,
    };
  }
}
